import { atom } from 'recoil'

export const badgeKeyState = atom({
    key: 'badgeKeyState',
    default: [],
});